import React from "react";
import { Box } from "@cloudscape-design/components";
import { DateFormatter, TimeDisplayMode } from "../../utils/DateFormatter";
import { LABELS } from "../../constants";

interface TimestampDisplayProps {
  date?: string;
  mode: TimeDisplayMode;
  fallback?: string;
}

export const TimestampDisplay: React.FC<TimestampDisplayProps> = ({ date, mode, fallback = LABELS.EMPTY_VALUE }) => {
  if (!date) {
    return <>{fallback}</>;
  }

  return (
    <div>
      <div>{DateFormatter.formatDate(date, fallback, mode)}</div>
      <Box variant="small" color="text-body-secondary">
        {DateFormatter.formatRelative(date)}
      </Box>
    </div>
  );
};
